import { render, staticRenderFns } from "./ProceedOrder.vue?vue&type=template&id=5d66691f&"
import script from "./ProceedOrder.vue?vue&type=script&lang=js&"
export * from "./ProceedOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProceedOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports